import React, { useState } from 'react';
import { Card, CardHeader, Collapse } from 'reactstrap';

type IAccordion = {
  title: string;
  id: string;
  children?: React.ReactNode;
};

const Accordion: React.FC<IAccordion> = ({ title, id, children }) => {
  const [isOpen, setIsOpen] = useState<boolean>(true);

  return (
    <Card className="accordion md-accordion custom-accordion" id={id} role="tablist" aria-multiselectable="true">
      <CardHeader onClick={() => setIsOpen(prev => !prev)} className="custom-accordion" role="tab">
        <a
          className="custom-accordion"
          data-toggle="collapse"
          data-parent={`#${id}`}
          href={`#${id}`}
          aria-expanded="true"
          aria-controls={`#${id}`}
        >
          <h5 className="mb-0 pl-0 custom-accordion">{title}</h5>
          <i className={`accordion-arrow-icon${isOpen ? '' : ' closed'}`} />
        </a>
      </CardHeader>

      <Collapse isOpen={isOpen}>{children}</Collapse>
    </Card>
  );
};

export default Accordion;
